import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="catalog-route"
        path="/catalog-info"
        component={Page} />,
    <Private exact
        key="catalog-route"
        path="/admin-catalog"
        component={Page} />
];

export default Routes;